import React, { useContext } from 'react';
import AccessoriesItem from './AccessoriesItem';
import ControlBar from './ControlBar';
import { toast } from 'react-toastify';
import { createItem } from './accessories.service';
import calculatePrice from '../../helpers/calculatePrice';
import { PriceContext } from '../../contexts/PriceContext';
import { WardrobesConfigsContext } from '../../contexts/WardrobesConfigsContext';
import { ActiveWardrobeContext } from '../../contexts/ActiveWardrobeContext';
import Button from 'components/buttons/Button';
function Notify() {
  toast.error(
    'W wybranej kolumnie nie ma już miejsca. Usuń akcesoria lub ułóż je w inny sposób, aby dodać kolejne.',
    {
      closeOnClick: true,
      position: 'top-right',
      autoClose: 10000,
      toastId: 1, // show only one
    },
  );
}

function Item({ item, wardrobe, ZG }) {
  const selectedItems = wardrobe.accessories.list;
  const updateList = wardrobe.update;

  const { wardrobesConfigs, setWardrobesConfigs } = useContext(WardrobesConfigsContext);
  const { activeWardrobe } = useContext(ActiveWardrobeContext);
  const { setPrice, price } = useContext(PriceContext);

  const selectedAvailableSpace = wardrobe.getAvailableSpace(item);
  const isAvailableSpace = !!selectedAvailableSpace;

  const isZGInAccessories =
    wardrobesConfigs[activeWardrobe].accessories['left'].some(item =>
      item.safo.toUpperCase().includes('ZG'),
    ) ||
    wardrobesConfigs[activeWardrobe].accessories['center'].some(item =>
      item.safo.toUpperCase().includes('ZG'),
    ) ||
    wardrobesConfigs[activeWardrobe].accessories['right'].some(item =>
      item.safo.toUpperCase().includes('ZG'),
    );

  const isZDInAccessories =
    wardrobesConfigs[activeWardrobe].accessories['left'].some(item =>
      item.safo.toUpperCase().includes('ZD'),
    ) ||
    wardrobesConfigs[activeWardrobe].accessories['center'].some(item =>
      item.safo.toUpperCase().includes('ZD'),
    ) ||
    wardrobesConfigs[activeWardrobe].accessories['right'].some(item =>
      item.safo.toUpperCase().includes('ZD'),
    );

  const NotifyNoZGMessage = ({ closeToast, actualItem }) => {
    return (
      <div>
        <span>By dodać oświetlenie dodatkowe konieczne jest dodanie oświetlenia głównego</span>
        <br />
        <Button
          text="Dodaj"
          click={() => {
            const itemInSelected = selectedItems.find(el => el.id === actualItem.id);

            if (!isAvailableSpace && !itemInSelected) {
              Notify();
              return;
            }

            const wardrobesConfigsCopy = wardrobesConfigs;
            wardrobesConfigsCopy[activeWardrobe].accessories[ZG.side].push(
              createItem(ZG, wardrobe.getAvailableSpace(ZG)),
            );

            setWardrobesConfigs(wardrobesConfigsCopy);

            if (item) {
              item.check = !item.check;
              if (item.check) {
                item.value = 1;
              } else {
                item.value = 0;
              }
            }

            if (itemInSelected) {
              let updatedAccessories = selectedItems.filter(el => el.id !== item.id);
              updateList(updatedAccessories);
            } else {
              add(item);
            }

            setPrice(calculatePrice(wardrobesConfigs[activeWardrobe]));

            closeToast();
          }}
        />
        <Button text="Anuluj" click={closeToast} />
      </div>
    );
  };

  function NotifyNoZG(actualItem) {
    toast(<NotifyNoZGMessage actualItem={actualItem} />, {
      closeOnClick: false,
      position: 'top-right',
      autoClose: 15000,
      hideProgressBar: true,
      toastId: 1, // show only one
      progress: undefined,
    });
  }

  const NotifyDeletedZDMessage = ({ closeToast, actualItem }) => {
    return (
      <div>
        <span>Usunięcie oświetlenia głównego spowoduje usunięcie oświetlenia dodatkowego</span>
        <br />
        <Button
          text="Tak, usuń"
          click={() => {
            const wardrobesConfigsCopy = wardrobesConfigs;
            let updatedAccessories = selectedItems.filter(el => el.id !== actualItem.id);

            const ZDToDeleteCenter = wardrobesConfigsCopy[
              activeWardrobe
            ].accessories.center.filter(el => el.safo.toUpperCase().includes('ZD'));
            const ZDToDeleteRight = wardrobesConfigsCopy[
              activeWardrobe
            ].accessories.right.filter(el => el.safo.toUpperCase().includes('ZD'));
            const ZDToDeleteLeft = wardrobesConfigsCopy[
              activeWardrobe
            ].accessories.left.filter(el => el.safo.toUpperCase().includes('ZD'));

            wardrobesConfigsCopy[activeWardrobe].accessories.left = wardrobesConfigsCopy[
              activeWardrobe
            ].accessories.left.filter(el => !ZDToDeleteLeft.find(item => item.id === el.id));

            wardrobesConfigsCopy[activeWardrobe].accessories.center = wardrobesConfigsCopy[
              activeWardrobe
            ].accessories.center.filter(el => !ZDToDeleteCenter.find(item => item.id === el.id));

            wardrobesConfigsCopy[activeWardrobe].accessories.right = wardrobesConfigsCopy[
              activeWardrobe
            ].accessories.right.filter(el => !ZDToDeleteRight.find(item => item.id === el.id));

            setWardrobesConfigs(wardrobesConfigsCopy);
            updateList(updatedAccessories);
            setPrice(calculatePrice(wardrobesConfigsCopy[activeWardrobe]));
            closeToast();
          }}
        />
        <Button text="Anuluj" click={closeToast} />
      </div>
    );
  };

  function NotifyDeletedZD(actualItem) {
    toast(<NotifyDeletedZDMessage actualItem={actualItem} />, {
      closeOnClick: false,
      position: 'top-right',
      autoClose: 15000,
      hideProgressBar: true,
      toastId: 1, // show only one
      progress: undefined,
    });
  }

  const add = item => {
    const newItem = createItem(item, selectedAvailableSpace);
    wardrobe.accessories.add(newItem);
    setPrice(calculatePrice(wardrobesConfigs[activeWardrobe]));
  };

  const changeCheck = () => {
    const itemInSelected = selectedItems.find(el => el.id === item.id);

    if (!isAvailableSpace && !itemInSelected) {
      Notify();
      return;
    }

    if (!isZGInAccessories && item.safo.toUpperCase().includes('ZD')) {
      NotifyNoZG(item);
      return;
    }

    if (item) {
      item.check = !item.check;
      if (item.check) {
        item.value = 1;
      } else {
        item.value = 0;
      }
    }

    if (itemInSelected) {
      let updatedAccessories = selectedItems.filter(el => el.id !== item.id);
      const wardrobesConfigsCopy = wardrobesConfigs;
      const ZDToDeleteCenter = wardrobesConfigsCopy[activeWardrobe].accessories.center.filter(el =>
        el.safo.toUpperCase().includes('ZD'),
      );
      const ZDToDeleteRight = wardrobesConfigsCopy[activeWardrobe].accessories.right.filter(el =>
        el.safo.toUpperCase().includes('ZD'),
      );
      const ZDToDeleteLeft = wardrobesConfigsCopy[activeWardrobe].accessories.left.filter(el =>
        el.safo.toUpperCase().includes('ZD'),
      );
      if (
        isZDInAccessories &&
        item.safo.toUpperCase().includes('ZG') &&
        (ZDToDeleteRight.length || ZDToDeleteCenter.length || ZDToDeleteLeft.length)
      ) {
        NotifyDeletedZD(item);
      } else {
        updateList(updatedAccessories);
      }
    } else {
      add(item);
    }

    setPrice(calculatePrice(wardrobesConfigs[activeWardrobe]));
  };

  const remove = item => {
    const lastFoundItem = selectedItems.filter(el => el.id === item.id).pop();

    const listItem = selectedItems.filter(el => el !== lastFoundItem);

    updateList(listItem);
    setPrice(calculatePrice(wardrobesConfigs[activeWardrobe]));
  };

  const onChangeValue = (item, method) => {
    if (!isAvailableSpace && method === 'plus') {
      Notify();
      changeValue(item);
    } else {
      changeValue(item, method);
    }
  };

  const changeValue = (item, method) => {
    switch (method) {
      case 'plus':
        return add(item);
      case 'minus':
        if (item.value > 0) {
          remove(item);
        }
        return item;
      default:
        return item;
    }
  };

  const validityCheckAndNotify = () => {
    if (!isAvailableSpace && item.check) {
      Notify();
    } else if (!isZGInAccessories && item.safo.toUpperCase().includes('ZD')) {
      NotifyNoZG();
    }
  };

  return (
    <div
      key={item.id}
      className={`accessories-wrap-item ${isAvailableSpace ? '' : 'error'}`}
      onClick={validityCheckAndNotify}>
      <AccessoriesItem item={item} changeCheck={changeCheck} key={item.id} price={price} />
      {item.check && <ControlBar item={item} changeValue={onChangeValue} />}
    </div>
  );
}

function AccessoriesList({ accessories, wardrobe, allAccessories }) {
  const sortedAccessories = accessories.sort((a, b) => {
    return a.name.localeCompare(b.name);
  });

  return (
    <>
      {sortedAccessories.map(item => (
        <Item
          wardrobe={wardrobe}
          item={item}
          key={item.id}
          ZG={allAccessories.find(i => i.safo.toUpperCase().includes('ZG'))}
        />
      ))}
    </>
  );
}

export default AccessoriesList;
